import { render } from "./UploadQuiz.vue?vue&type=template&id=1002aafe&scoped=true"
import script from "./UploadQuiz.vue?vue&type=script&lang=js"
export * from "./UploadQuiz.vue?vue&type=script&lang=js"

import "./UploadQuiz.vue?vue&type=style&index=0&id=1002aafe&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1002aafe"]])

export default __exports__